module.exports = __webpack_public_path__ + "static/media/icon-lab.5ed44d4c.svg";